"use client";

import { useMemo } from "react";
import { useParticipants } from "@livekit/components-react";
import { parseParticipantAvatarFromMetadata } from "@client/utils/livekitParticipantMetadata";

/** Avatar URLs keyed by LiveKit participant identity (from token metadata + local join fallback). */
export function useParticipantAvatarByIdentity(localAvatarUrl?: string | null): Map<string, string> {
  const participants = useParticipants();

  const metadataSignature = participants.map((p) => `${p.identity}:${p.metadata ?? ""}`).join("|");

  return useMemo(() => {
    const map = new Map<string, string>();
    for (const participant of participants) {
      if (participant.isLocal && localAvatarUrl) {
        map.set(participant.identity, localAvatarUrl);
        continue;
      }
      const url = parseParticipantAvatarFromMetadata(participant.metadata);
      if (url) map.set(participant.identity, url);
    }
    return map;
    // metadataSignature captures metadata changes without stale participant references
  }, [participants, localAvatarUrl, metadataSignature]);
}
